export const commitmentRecordConstants = {
  COMMITMENT_RECORD_CREATE_LOADING: 'COMMITMENT_RECORD_CREATE_LOADING',
  COMMITMENT_RECORD_CREATE_SUCCESS: 'COMMITMENT_RECORD_CREATE_SUCCESS',
  COMMITMENT_RECORD_CREATE_FAILURE: 'COMMITMENT_RECORD_CREATE_FAILURE',
  COMMITMENT_RECORD_ERROR_RELOAD: 'COMMITMENT_RECORD_ERROR_RELOAD',

  COMMITMENT_RECORD_LIST_LOADING: 'COMMITMENT_RECORD_LIST_LOADING',
  COMMITMENT_RECORD_LIST_SUCCESS: 'COMMITMENT_RECORD_LIST_SUCCESS',
  COMMITMENT_RECORD_LIST_FAILURE: 'COMMITMENT_RECORD_LIST_FAILURE',

  COMMITMENT_RECORD_EDIT_LOADING: 'COMMITMENT_RECORD_EDIT_LOADING',
  COMMITMENT_RECORD_EDIT_SUCCESS: 'COMMITMENT_RECORD_EDIT_SUCCESS',
  COMMITMENT_RECORD_EDIT_FAILURE: 'COMMITMENT_RECORD_EDIT_FAILURE',

  COMMITMENT_RECORD_DELETE_LOADING: 'COMMITMENT_RECORD_DELETE_LOADING',
  COMMITMENT_RECORD_DELETE_SUCCESS: 'COMMITMENT_RECORD_DELETE_SUCCESS',
  COMMITMENT_RECORD_DELETE_FAILURE: 'COMMITMENT_RECORD_DELETE_FAILURE'
};
